<div class="appmain">
  <scanner></scanner>
  <app-page-loader></app-page-loader>
  <div (click)="bodyClick()" class="mat-typography appbody">
    <router-outlet></router-outlet>
  </div>
  <app-tutorials></app-tutorials>
  <app-footer></app-footer>
</div>
